import React from 'react';
import PropTypes from 'prop-types';
import styles from './link.module.scss';

const Link = ({item, active}) => {
  return (
    <a
      href={item.url}
      className={`${active ? styles.currentPage : ''}`}
    >
      {item.linkText}
    </a>
  )
}

Link.propTypes = {
  item: PropTypes.any.isRequired,
  active: PropTypes.bool.isRequired
}

export default Link;
